import { render, staticRenderFns } from "./iscritto.html?vue&type=template&id=04c65c1b&"
import script from "./iscritto.vue?vue&type=script&lang=ts&"
export * from "./iscritto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports